<div fxLayout="column" fxLayoutGap="16px">
  <div class="flex gap-4">
    <pt-search-field class="flex-1">
      <input
        #search
        matInput
        placeholder="Search"
        (keyup)="searchConditions(search.value)"
      />
    </pt-search-field>
    <button mat-raised-button color="primary" (click)="addCondition()">
      Create Condition
    </button>
  </div>

  <pr-empty-state
    *ngIf="emptyState$ | async"
    image="list"
    title="condition configurations"
  />

  <div *ngIf="dataSource" class="mat-elevation-z1">
    <mat-progress-bar
      *ngIf="dataSource.loading$ | async"
      mode="indeterminate"
    />

    <div *ngIf="dataSource.filteredData.length" class="flex h-full flex-col">
      <mat-table matSort matSortDisableClear [dataSource]="dataSource">
        <ng-container matColumnDef="icon">
          <mat-header-cell *matHeaderCellDef />
          <mat-cell *matCellDef="let config" class="grow-0 basis-16">
            <mat-icon
              *ngIf="config.display?.icon.slug"
              [ngStyle]="{ color: config.display.colour.value }"
              [svgIcon]="config.display.icon.slug"
            />
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Name
          </mat-header-cell>
          <mat-cell *matCellDef="let config">
            <a [routerLink]="config.ref.id | map: getRoute : this">{{
              config.name
            }}</a>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayColumns" />
        <mat-row *matRowDef="let row; columns: displayColumns" />
      </mat-table>

      <mat-paginator
        #paginator
        class="sticky bottom-0 z-50"
        showFirstLastButtons
        [length]="dataSource.data.length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
      />
    </div>
    <pr-empty-state
      *ngIf="emptySearch$ | async"
      image="search"
      title="search results"
      [searchInputValue]="search.value"
    />
  </div>
</div>
